import { render, staticRenderFns } from "./CatalogoArquivos.vue?vue&type=template&id=534c9264&scoped=true&"
import script from "./CatalogoArquivos.vue?vue&type=script&lang=js&"
export * from "./CatalogoArquivos.vue?vue&type=script&lang=js&"
import style0 from "./CatalogoArquivos.vue?vue&type=style&index=0&id=534c9264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c9264",
  null
  
)

export default component.exports